<script>
    import { push, pop, replace } from "svelte-spa-router";
	import Icon from "svelte-awesome";
    import { faTimes } from "@fortawesome/free-solid-svg-icons";
    import { onBreak } from "./stores";
    // paramètres bind
    export let gameName, difficulty;

    if(!gameName) {
        gameName = "reactivity";
    }

    function handleClose() {
        onBreak.set(false);
    }
    
    function handleRanking() {
        push('/ranking/'+gameName+'/'+difficulty);
    }

    function homeRetry() {
        document.location.reload(true);
    }

    function handleDifficulty() {
        push('/'+gameName);
    }

    function handleHome() {
        push('/');
    }

</script>

<style>
    .pop-up-break {
        @apply absolute flex justify-center items-center top-0 left-0 w-screen h-screen z-10;
        background: rgba(0, 0, 0, 0.336);
    }
    .container-pop-up {
        @apply h-3/6 w-4/5 flex justify-center items-center bg-beige-light shadow-2xl rounded-md;
        max-height: 70vh;
        max-width: 400px;
    }
    .buttons-menu button {
        @apply mx-1.5 my-1.5 outline-none;
    }
</style>

<div class="pop-up-break">
    <div class="relative container-pop-up">
        <div class="absolute top-2 right-3 cursor-pointer" on:click={handleClose}>
            <Icon data={faTimes} scale="1.4" />
        </div>
        <div class="block">
            <div class="font-medium text-2xl text-center mb-4">Pause</div>
            <div class="buttons-menu flex flex-col">
                <button class="button-{gameName}" on:click={handleRanking}>Classement</button>
                <button class="button-{gameName}" on:click={handleClose}>Recommencer</button>
                <button class="button-{gameName}" on:click={handleDifficulty}>Choix de la difficulté</button>
                <button class="button-{gameName}-bg" on:click={handleHome}>Accueil</button>
            </div>
        </div>
    </div>
</div>
